import React from 'react';

import './Footer.scss';
import footerLogo from './images/footer_logo.png';

export default function Footer () {
    return (
        <footer className="footer">
            <div className="container-fluid">
                <div className="row vcenter">
                    <div className="col-md-2 col-sm-3 col-sm-offset-3 col-xs-6 col-md-offset-0 text-center footer-logo-container">
                        <img className="footer-logo" src={footerLogo} alt="Fasig-Tipton Logo" />
                        <div className="footer-logo-text text-center">© 2020 Fasig-Tipton Company.<br />All rights reserved.
                            <br />
                            <a href="https://www.fasigtipton.com/docs/Terms_of_Use.pdf">Terms Of Use</a> |
                            <a href="https://www.fasigtipton.com/docs/Privacy_Policy.pdf">Privacy Policy</a>   
                        </div>
                    </div>
                    <div className="col-md-2 col-xs-5 col-sm-4 text-left address-footer">
                        <div className="footer_contact_info">
                            <ul className="list-unstyled">
                                <li className="bolder">Fasig-Tipton Company, Inc.</li>
                                <li className="lighter">2400 Newtown Pike</li>
                                <li className="lighter">Lexington, KY 40511</li>
                                <li className="lighter">Email: <a href="mailto:info@fasigtipton.com" target="_blank">info@fasigtipton.com</a></li>
                                <li className="lighter">Phone: (859) 255-1555</li>
                                <li className="lighter">Fax: (859) 254-0794</li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-md-3 col-xs-12 text-center">
                        <a 
                            href="https://login.fasigtipton.com/#/login" target="_blank"
                        >
                            <img className="img-fluid" style={{ margin: "0 auto" }} 
                                src="https://www.fasigtipton.com/themes/fasigtipton/images/consignor_portal_graphic.png"
                                alt="Consignor Login"
                            />
                        </a>
                    </div>
                    <div className="col-md-2 col-sm-12 col-xs-12 text-center social-media-footer">
                        <ul className="list-unstyled social-media-icons">
                            <li><a href="https://www.facebook.com/FasigTiptonCo/" target="_blank">
                                <img src="https://www.fasigtipton.com/themes/fasigtipton/images/social_media_facebook.png" alt="" /></a></li>
                            <li><a href="https://twitter.com/fasigtiptonco" target="_blank">
                                <img src="https://www.fasigtipton.com/themes/fasigtipton/images/social_media_twitter.png" alt="" /></a></li>
                            <li><a href="https://www.instagram.com/fasigtipton/" target="_blank">
                                <img src="https://www.fasigtipton.com/themes/fasigtipton/images/social_media_instagram.png" alt="" /></a></li>
                            <li><a href="https://www.youtube.com/user/FasigTiptonCo" target="_blank">
                                <img src="https://www.fasigtipton.com/themes/fasigtipton/images/social_media_youtube.png" alt="" /></a></li>
                        </ul>
                        <div className="connect-with-us">Connect with us!</div>
                    </div>
                </div>
            </div>
        </footer>
    );
}
